import React, { useCallback, useRef } from 'react';
import './builder-shell.scss';

export const ResizablePanel = ({
  width,
  onResize,
  side = 'left',
  children,
  className = '',
  id,
}) => {
  const dragging = useRef(false);

  const onMouseDown = useCallback((e) => {
    e.preventDefault();
    dragging.current = true;
    const startX = e.clientX;
    const startWidth = width;

    const onMove = (ev) => {
      if (!dragging.current) return;
      const delta = side === 'left' ? ev.clientX - startX : startX - ev.clientX;
      onResize(startWidth + delta);
    };

    const onUp = () => {
      dragging.current = false;
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  }, [width, onResize, side]);

  return (
    <div
      id={id}
      className={`builder-resizable-panel builder-resizable-panel--${side} ${className}`}
      style={{ width }}
    >
      <div
        className={`builder-resizable-panel__handle builder-resizable-panel__handle--${side === 'left' ? 'right' : 'left'}`}
        onMouseDown={onMouseDown}
        role="separator"
        aria-orientation="vertical"
        aria-label="Resize panel"
      />
      <div className="builder-resizable-panel__content">{children}</div>
    </div>
  );
};

export default ResizablePanel;
